/**
 * Preferences Endpoints - Centralized API URLs
 */

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const PREFERENCES_ENDPOINTS = {
  BASE: `${API_URL}/preferences`,
  GET: `${API_URL}/preferences`,
  SAVE: `${API_URL}/preferences`,
} as const;

export default PREFERENCES_ENDPOINTS;
